
import Vue from 'vue';
export default Vue.extend({
  props: {
    validate: {
      type: Object,
      validator: (value: any) => {
        if (!value) {
          value = {};
        }
        if (!value.$params) {
          value.$params = {};
        }
        return true;
      },
    },
    msgRequired: {
      type: String,
      default: 'Field is required',
    },
    message: {
      type: String,
    },
  },
});
